import React, { useState } from 'react';
import { ChevronRight, Menu, X } from 'lucide-react';

const navigationLinks = [
  { label: 'How It Works', href: 'https://valleyeats.ca/how-it-works' },
  { label: 'About', href: 'https://valleyeats.ca/about' },
  { label: 'Partners', href: 'https://valleyeats.ca/restaurant-partners' },
  { label: 'Couriers', href: 'https://valleyeats.ca/courier-hub', active: true },
  { label: 'Help', href: 'https://valleyeats.ca/help' },
];

const Header: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const renderNavigationLink = (link: typeof navigationLinks[number]) => (
    <a
      key={link.label}
      className={`header-nav-link${link.active ? ' header-nav-link--active' : ''}`}
      href={link.href}
      onClick={() => setMenuOpen(false)}
    >
      {link.label}
    </a>
  );

  return (
    <>
      <header className="site-header">
        <div className="header-inner">
          <a className="header-brand" href="https://valleyeats.ca/" aria-label="Valley Eats home">
            <img
              src={`${process.env.PUBLIC_URL}/valley-eats-circle-logo.png`}
              alt="Valley Eats"
              className="brand-logo"
            />
            <span className="header-country-badge" aria-hidden="true">🇨🇦</span>
          </a>

          <nav className="desktop-header-nav" aria-label="Primary navigation">
            {navigationLinks.map(renderNavigationLink)}
            <a className="header-order-button" href="https://order.valleyeats.ca/">Order Now</a>
          </nav>

          <button
            className="mobile-menu-toggle"
            type="button"
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
            aria-controls="mobile-header-navigation"
            onClick={() => setMenuOpen((current) => !current)}
          >
            {menuOpen ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
          </button>
        </div>

        {menuOpen && (
          <nav className="mobile-header-nav" id="mobile-header-navigation" aria-label="Mobile navigation">
            <div className="mobile-header-nav__inner">
              {navigationLinks.map(renderNavigationLink)}
              <a className="header-nav-link mobile-contact-link" href="https://valleyeats.ca/contact" onClick={() => setMenuOpen(false)}>Contact</a>
              <a className="header-order-button" href="https://order.valleyeats.ca/" onClick={() => setMenuOpen(false)}>Order Now</a>
            </div>
          </nav>
        )}
      </header>

      <nav className="header-breadcrumb" aria-label="Breadcrumb">
        <div className="header-breadcrumb__inner">
          <a href="https://valleyeats.ca/">Home</a>
          <ChevronRight aria-hidden="true" />
          <span>Courier Hub</span>
        </div>
      </nav>
    </>
  );
};

export default Header;
